(function () {
  'use strict';

  angular
      .module('tfc.retailer.ConsumerSampling')
      .factory('consumerSampling', consumerSampling);

  // @ngInject
  function consumerSampling(ChartService, SamplingSegmentMap){

    return consumerSampling;

    function setSampling(summaryDetails){
      if(_.isArray(summaryDetails)){
        var isBrandSampling = _.some(summaryDetails,
            function(s) { return s.brandConsumerSamplingDetail && s.brandConsumerSamplingDetail.brandKey; });
        return _(summaryDetails).map(function(samplingObj){
          var samplingSegment = (samplingObj.brandConsumerSamplingDetail) ? SamplingSegmentMap[samplingObj.brandConsumerSamplingDetail.samplingSegment] : SamplingSegmentMap[samplingObj.universalConsumerSamplingDetail.samplingSegment];
          return _.assign(samplingObj, {
            'samplingSegment': samplingSegment.title,
            'imgSrc': samplingSegment.imgSrc,
            'showBenchmark': false,
            'isBrandConsumerDetailsAvailable': isBrandSampling,
            'showBenchmarkLabel':  samplingObj.hasOwnProperty('universalConsumerSamplingDetail')
          });
        }).sortBy(function (o) {
          return o.samplingSegment.length;
        }).value();
      }
    }

    function consumerSampling(fillFunc) {
      return fillFunc().then(function(summaryDetails){
        return setSampling(summaryDetails);
      });
    }
  }

})();